module.exports = __webpack_public_path__ + "static/media/02-menu.b6de009e.png";